module.exports = __webpack_public_path__ + "img/rmtj.0f079570.png";